/* eslint-disable no-console, no-undef, function-paren-newline */
const stringToHash = (str) => {
  const url = `${window.facebookApiUrl}hash`;
  return new Promise((resolve, reject) => {
    fetch(url, {
      body: str,
      headers: {
        'content-type': 'text/plain',
      },
      method: 'POST',
    })
      .then((response) => {
        if (response.ok) {
          response.text().then(resolve);
        } else {
          response.text().then(reject);
        }
      })
      .catch(console.error);
  });
};

const convertLead = (options) => {
  const {
    eventName,
    eventType,
    userDataHashed,
    testEventCode,
    userData,
  } = options;
  // Deduping id (must be UNIX timestamp in GMT/UTC)
  const eventId = Math.floor(new Date(new Date().toUTCString()).getTime() / 1000);
  // Existing pixel code
  if (fbq) {
    fbq(eventType, eventName, userData, { event_id: eventId });
  }
  // Conversion API
  const json = JSON.stringify({
    data: [
      {
        event_name: eventName,
        event_id: eventId,
        event_source_url: window.location.href,
        event_time: eventId,
        user_data: userDataHashed,
      },
    ],
    test_event_code: testEventCode,
  });
  const url = `/api/service/fbconvert?json=${json}`;
  fetch(url, {
    headers: {
      'content-type': 'text/plain',
    },
    method: 'POST',
  })
    /* .then((response) => {
      console.log(response);
    }) */
    .catch(console.error);
};

const encodeUserData = (options) => {
  const { userData } = options;
  // Loop through object
  const promises = [];
  options.userDataHashed = {};
  Object.keys(userData).forEach((key) => {
    promises.push(
      stringToHash(userData[key])
        .then((hash) => {
          if (hash) {
            options.userDataHashed[key] = hash.replace(/"/g, '');
          }
        })
        .catch((error) => {
          console.log(error);
        }),
    );
  });
  Promise.all(promises)
    .then(() => {
      convertLead(options);
    });
};

const springsFbq = (eventType, eventName, userData, testEventCode) => {
  const options = {
    eventType,
    eventName,
    userData,
    testEventCode,
  };
  if (userData) {
    // Hash userData
    encodeUserData(options);
  } else {
    convertLead(options);
  }
};

window.springsFbq = springsFbq;

export default springsFbq;
/* eslint-disable no-console, no-undef, function-paren-newline */
